// extracted by mini-css-extract-plugin
export default {"innerWrapper":"iF-z","tooltipWrapper":"jF-z","icon":"kF-z","tooltip":"lF-z","content":"mF-z"};